export const ProductDevelopmentPanelSidebarData = [
  {
    title: "VP OPERATIONS PANEL",
    subNav: [
      {
        title: "TECHNICAL SUPPORT",
        path: "technicalsupport",
        cName: "sub-nav",
      },
      {
        title: "ADMISSION - EDUTECH",
        subNav: [
          {
            title: "BATCHWISE COUNT",
            path: "cxoBatchwiseCount",
            cName: "sub-nav",
          },
          {
            title: "DATEWISE COUNT",
            path: "datewisecount",
            cName: "sub-nav",
          },
          {
            title: "REVENUE DETAILS",
            path: "revenuedetails",
            cName: "sub-nav",
          },
        ],
      },
      {
        title: "DOUBT SOLVE REVIEW",
        path: "doubtsolvereview",
        cName: "sub-nav",
      },
      {
        title: "ENROLLED EDUTECH",
        path: "transactionedutech",
        cName: "sub-nav",
      },
      {
        title: "ENROLLED EDUTECH STUDYMATERIAL",
        path: "transactionEdutechStudyMaterial",
        cName: "sub-nav",
      },
      {
        title: "REGISTRATION DETAILS",
        path: "registrationdetails",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "TEACHER TASK PANEL",
    subNav: [
      {
        title: "TEACHER TASK PLAN",
        subNav: [
          {
            title: "ADD TEACHER TASK",
            path: "addTeacherTask",
            cName: "sub-nav",
          },
          {
            title: "EDIT / DELETE",
            path: "editDeleteTeacherTask",
            cName: "sub-nav",
          },
        ],
      },
      {
        title: "TEACHER PERFORMANCE",
        path: "teacherPerformance",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "DATA ENTRY PANEL",
    subNav: [
      {
        title: "TOPIC",
        subNav: [
          {
            title: "CREATE",
            path: "createtopic",
            cName: "sub-nav",
          },
          {
            title: "EDIT / DELETE",
            path: "editdeletetopic",
            cName: "sub-nav",
          },
        ],
      },
      {
        title: "SUB-TOPIC",
        subNav: [
          {
            title: "CREATE",
            path: "createsubtopic",
            cName: "sub-nav",
          },
          {
            title: "EDIT / DELETE",
            path: "editdeletesubtopic",
            cName: "sub-nav",
          },
        ],
      },
      {
        title: "LECTURE",
        subNav: [
          {
            title: "CREATE",
            path: "createLecture",
            cName: "sub-nav",
          },
          {
            title: "EDIT / DELETE",
            path: "editDeleteLecture",
            cName: "sub-nav",
          },
        ],
      },
      {
        title: "LIVE VIDEO",
        subNav: [
          {
            title: "ADD VIDEO",
            path: "addLiveVideoNew",
            cName: "sub-nav",
          },
          {
            title: "EDIT / DELETE",
            path: "editDeleteLiveVideoNew",
            cName: "sub-nav",
          },
        ],
      },
      {
        title: "PREMIER VIDEO",
        subNav: [
          {
            title: "ADD VIDEO",
            path: "addPremierVideo",
            cName: "sub-nav",
          },
          {
            title: "EDIT / DELETE",
            path: "editDeletePremierVideo",
            cName: "sub-nav",
          },
        ],
      },
      {
        title: "FREE USER VIDEO",
        subNav: [
          {
            title: "ADD VIDEO",
            path: "addFreeUserVideo",
            cName: "sub-nav",
          },
          {
            title: "EDIT / DELETE",
            path: "editDeleteFreeUserVideo",
            cName: "sub-nav",
          },
        ],
      },
      {
        title: "LIVE RECORDED VIDEO",
        subNav: [
          {
            title: "ADD VIDEO",
            path: "addliverecordedvideo",
            cName: "sub-nav",
          },
          {
            title: "EDIT / DELETE",
            path: "editdeleteliverecordedvideo",
            cName: "sub-nav",
          },
        ],
      },
      {
        title: "COPY RECORDED LECTURE",
        subNav: [
          {
            title: "COPY LECTURE",
            path: "copyrecordedlecture",
            cName: "sub-nav",
          },
          {
            title: "EDIT / DELETE",
            path: "editdeletecopyrecordedlecture",
            cName: "sub-nav",
          },
          {
            title: "BATCH CLONE",
            path: "batchClone",
            cName: "sub-nav",
          },
          {
            title: "BATCH CLONE & COPY LIVE TO LIVE LECTURE",
            path: "batchCloneCopyLiveToLiveLecture",
            cName: "sub-nav",
          },
          {
            title: "COPY LIVE TO RECORDED BATCH & RECORDED LECTURE",
            path: "copyLiveToRecordedBatchRecordedLecture",
            cName: "sub-nav",
          },
          {
            title: "COPY LIVE TO RECORDED BATCH",
            path: "liveToRecorded",
            cName: "sub-nav",
          },
          {
            title: "COPY LIVE TO RECORDED LECTURE",
            path: "liveToRecordedLecture",
            cName: "sub-nav",
          },
          {
            title: "COPY LIVE TO LIVE LECTURE",
            path: "liveToLiveLecture",
            cName: "sub-nav",
          },
        ],
      },
      {
        title: "NOTIFICATION",
        subNav: [
          {
            title: "CREATE",
            path: "createnotification",
            cName: "sub-nav",
          },
          {
            title: "EDIT / DELETE",
            path: "editdeletenotification",
            cName: "sub-nav",
          },
        ],
      },
      {
        title: "ASSIGN TEACHER",
        subNav: [
          {
            title: "CREATE",
            path: "createassignteacher",
            cName: "sub-nav",
          },
          {
            title: "EDIT / DELETE",
            path: "editdeleteassignteacher",
            cName: "sub-nav",
          },
        ],
      },
      {
        title: "ADD PART",
        path: "addPart",
        cName: "sub-nav",
      },
      {
        title: "EXAM SET",
        subNav: [
          {
            title: "CREATE",
            path: "createexamset",
            cName: "sub-nav",
          },
          {
            title: "EDIT / DELETE",
            path: "editdeleteexamset",
            cName: "sub-nav",
          },
          {
            title: "COPY EXAM SET",
            path: "copyexamset",
            cName: "sub-nav",
          },
          {
            title: "Question Bank Assign",
            path: "assignQuestionToExamSet",
            cName: "sub-nav",
          },
        ],
      },
      {
        title: "QUESTION",
        subNav: [
          {
            title: "CREATE",
            path: "createquestion",
            cName: "sub-nav",
          },
          {
            title: "EDIT / DELETE",
            path: "editdeletequestion",
            cName: "sub-nav",
          },
          {
            title: "SET QUESTION ORDER",
            path: "questionOrder",
            cName: "sub-nav",
          },
        ],
      },
      {
        title: "TEACHER SUPPORT",
        path: "teachersupport",
        cName: "sub-nav",
      },
      {
        title: "LIVE CLASS SCHEDULE",
        path: "liveclassschedule",
        cName: "sub-nav",
      },
      {
        title: "SYLLABUS",
        path: "syllabusDashboard",
        cName: "sub-nav",
      },
      {
        title: "QUESTION BANK",
        subNav: [
          {
            title: "CREATE",
            path: "questionBankEditor",
            cName: "sub-nav",
          },
          {
            title: "EDIT / DELETE",
            path: "editDeleteQuestionBank",
            cName: "sub-nav",
          },
          {
            title: "LECTURE ADD / EDIT",
            path: "replaceLecture",
            cName: "sub-nav",
          },
        ],
      },
      {
        title: "IMPORT QUESTIONS",
        path: "importQuestions",
        cName: "sub-nav",
      },
      {
        title: "COPY PACKAGE",
        subNav: [
          {
            title: "COPY PACKAGE",
            path: "copyPackage",
            cName: "sub-nav",
          },
          {
            title: "EDIT / DELETE",
            path: "editCopyPackage",
            cName: "sub-nav",
          },
        ],
      },
      {
        title: "Question Of The Day",
        subNav: [
          {
            title: "CREATE",
            path: "createQuestionOfTheday",
            cName: "sub-nav",
          },
          {
            title: "EDIT/DELETE",
            path: "editQuestionOftheday",
            cName: "sub-nav",
          },
        ],
      },
      {
        title: "MOCK TEST RESULT",
        path: "MockTestResult",
        cName: "sub-nav",
      },
      {
        title: "App Feature",
        subNav: [
          {
            title: "CREATE",
            path: "createAppFeature",
            cName: "sub-nav",
          },
          {
            title: "EDIT/DELETE",
            path: "editAppFeature",
            cName: "sub-nav",
          },
        ],
      },
      {
        title: "STUDENT MIGRATION",
        path: "studentMigration",
        cName: "sub-nav",
      },
      {
        title: "LECTURE LINK MANAGEMENT",
        path: "lectureLinkManagement",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "ADMIN PANEL",
    subNav: [
      {
        title: "EXAM NAME",
        subNav: [
          {
            title: "CREATE",
            path: "createexam",
            cName: "sub-nav",
          },
          {
            title: "EDIT / DELETE",
            path: "editdeleteexam",
            cName: "sub-nav",
          },
        ],
      },
      {
        title: "SUB EXAM NAME",
        subNav: [
          {
            title: "CREATE",
            path: "createsubexam",
            cName: "sub-nav",
          },
          {
            title: "EDIT / DELETE",
            path: "editdeletesubexam",
            cName: "sub-nav",
          },
        ],
      },
      {
        title: "EXAM STREAM",
        subNav: [
          {
            title: "CREATE",
            path: "createparentcourse",
            cName: "sub-nav",
          },
          {
            title: "EDIT / DELETE",
            path: "editdeleteparentcourse",
            cName: "sub-nav",
          },
        ],
      },
      {
        title: "EXAM CATEGORY",
        path: "createExamSection",
        cName: "sub-nav",
      },
      {
        title: "LANGUAGE",
        subNav: [
          {
            title: "CREATE",
            path: "createlanguage",
            cName: "sub-nav",
          },
          {
            title: "EDIT / DELETE",
            path: "editdeletelanguage",
            cName: "sub-nav",
          },
        ],
      },
      {
        title: "ASSIGN EXAM STREAM",
        path: "createassignexamstream",
        cName: "sub-nav",
      },
      {
        title: "SUBJECT",
        subNav: [
          {
            title: "CREATE",
            path: "createsubject",
            cName: "sub-nav",
          },
          {
            title: "EDIT / DELETE",
            path: "editdeletesubject",
            cName: "sub-nav",
          },
        ],
      },
      {
        title: "MAIN CATEGORY",
        subNav: [
          {
            title: "CREATE",
            path: "createmaincategory",
            cName: "sub-nav",
          },
          {
            title: "EDIT / DELETE",
            path: "editdeletemaincategory",
            cName: "sub-nav",
          },
        ],
      },
      {
        title: "SECTION",
        subNav: [
          {
            title: "CREATE",
            path: "createsection",
            cName: "sub-nav",
          },
          {
            title: "EDIT / DELETE",
            path: "editdeletesection",
            cName: "sub-nav",
          },
        ],
      },
      {
        title: "ASSIGN BOOKS",
        subNav: [
          {
            title: "CREATE",
            path: "createassignbooks",
            cName: "sub-nav",
          },
          {
            title: "EDIT / DELETE",
            path: "editdeleteassignbooks",
            cName: "sub-nav",
          },
        ],
      },
      {
        title: "PACKAGE",
        subNav: [
          {
            title: "CREATE",
            path: "createpackage",
            cName: "sub-nav",
          },
          {
            title: "EDIT / DELETE",
            path: "editdeletepackage",
            cName: "sub-nav",
          },
        ],
      },
      {
        title: "PACKAGE EXTEND",
        subNav: [
          {
            title: "CREATE",
            path: "createpackageextend",
            cName: "sub-nav",
          },
          {
            title: "EDIT / DELETE",
            path: "editdeletepackageextend",
            cName: "sub-nav",
          },
        ],
      },
      {
        title: "TEACHER",
        subNav: [
          {
            title: "CREATE",
            path: "createteacher",
            cName: "sub-nav",
          },
          {
            title: "EDIT / DELETE",
            path: "editdeleteteacher",
            cName: "sub-nav",
          },
        ],
      },
      {
        title: "ASSIGN UNITS",
        subNav: [
          {
            title: "CREATE",
            path: "createassignunits",
            cName: "sub-nav",
          },
          {
            title: "EDIT / DELETE",
            path: "editdeleteassignunit",
            cName: "sub-nav",
          },
        ],
      },
      {
        title: "PATTERN",
        subNav: [
          {
            title: "CREATE",
            path: "createpattern",
            cName: "sub-nav",
          },
          {
            title: "EDIT / DELETE",
            path: "editdeletepattern",
            cName: "sub-nav",
          },
        ],
      },
      {
        title: "BB MEETING ID",
        subNav: [
          {
            title: "CREATE",
            path: "createbbmeetingid",
            cName: "sub-nav",
          },
          {
            title: "EDIT / DELETE",
            path: "editdeletebbmeetingid",
            cName: "sub-nav",
          },
          {
            title: "BIND MEETING IDS",
            path: "bindbbbmeeting",
            cName: "sub-nav",
          },
        ],
      },
      {
        title: "BASE OFFER DISCOUNT",
        subNav: [
          {
            title: "ADD",
            path: "baseOfferDiscount",
            cName: "sub-nav",
          },
          {
            title: "EDIT / DELETE",
            path: "editBaseOfferDiscount",
            cName: "sub-nav",
          },
        ],
      },
      {
        title: "BASE PRICE",
        subNav: [
          {
            title: "ADD BASE PRICE",
            path: "createBasePrice",
            cName: "sub-nav",
          },
          {
            title: "EDIT / DELETE",
            path: "editDeleteBasePrice",
            cName: "sub-nav",
          },
        ],
      },
      {
        title: "FIXED DISCOUNT",
        subNav: [
          {
            title: "ADD FIXED DISCOUNT",
            path: "addFixedDiscount",
            cName: "sub-nav",
          },
          {
            title: "EDIT / DELETE",
            path: "editFixedDiscount",
            cName: "sub-nav",
          },
        ],
      },
      {
        title: "WEB FREE YT LECTURE",
        subNav: [
          {
            title: "ADD",
            path: "addFreeYTLectures",
            cName: "sub-nav",
          },
          {
            title: "EDIT / DELETE",
            path: "editFreeYTLectures",
            cName: "sub-nav",
          },
        ],
      },
      {
        title: "CATEGORY INCLUDE DESCRIPTION",
        path: "addNewCatDesc",
        cName: "sub-nav",
      },
      {
        title: "COPY CATEGORY INCLUDE",
        subNav: [
          {
            title: "COPY",
            path: "copyCategoryInclude",
            cName: "sub-nav",
          },
          {
            title: "EDIT/DELETE",
            path: "editDeleteCategoryInclude",
            cName: "sub-nav",
          },
        ],
      },
      {
        title: "ADD RECORDED LECTURE IN COURSE",
        path: "addRecordedLectureInCourse",
        cName: "sub-nav",
      },
      {
        title: "BATCH ANALYSIS",
        path: "batchAnalysis",
        cName: "sub-nav",
      },
      {
        title: "Festive Banner",
        subNav: [
          {
            title: "ADD",
            path: "addFestiveBanner",
            cName: "sub-nav",
          },
        ],
      },
      {
        title: "Global Special Discount",
        path: "globalSpecialDiscount",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "MOVEMENTS OF MEETING",
    subNav: [
      {
        title: "MOVEMENTS OF MEETING",
        path: "movementsOfMeeting",
        cName: "sub-nav",
      },
      {
        title: "EDIT/DELETE",
        path: "editMovementsOfMeeting",
        cName: "sub-nav",
      },
    ],
  },
];

export const ProductDevelopmentPanelEmpSidebarData = [
  {
    title: "EMPLOYEE DETAILS",
    subNav: [
      {
        title: "Dashboard",
        path: "dashboard",
        cName: "sub-nav",
      },
      {
        title: "My Profile",
        path: "userProfile",
        cName: "sub-nav",
      },
      {
        title: "Policies",
        path: "policy",
        cName: "sub-nav",
      },
      {
        title: "KRA/KPI",
        path: "kraKpi",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "VP OPERATIONS PANEL",
    subNav: [
      {
        title: "TECHNICAL SUPPORT",
        path: "technicalsupport",
        cName: "sub-nav",
      },
      {
        title: "ADMISSION - EDUTECH",
        subNav: [
          {
            title: "BATCHWISE COUNT",
            path: "cxoBatchwiseCount",
            cName: "sub-nav",
          },
          {
            title: "DATEWISE COUNT",
            path: "datewisecount",
            cName: "sub-nav",
          },
          {
            title: "REVENUE DETAILS",
            path: "revenuedetails",
            cName: "sub-nav",
          },
        ],
      },
      {
        title: "DOUBT SOLVE REVIEW",
        path: "doubtsolvereview",
        cName: "sub-nav",
      },
      {
        title: "ENROLLED EDUTECH",
        path: "transactionedutech",
        cName: "sub-nav",
      },
      {
        title: "ENROLLED EDUTECH STUDYMATERIAL",
        path: "transactionEdutechStudyMaterial",
        cName: "sub-nav",
      },
      {
        title: "REGISTRATION DETAILS",
        path: "registrationdetails",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "TEACHER TASK PANEL",
    subNav: [
      {
        title: "TEACHER TASK PLAN",
        subNav: [
          {
            title: "ADD TEACHER TASK",
            path: "addTeacherTask",
            cName: "sub-nav",
          },
          {
            title: "EDIT / DELETE",
            path: "editDeleteTeacherTask",
            cName: "sub-nav",
          },
        ],
      },
      {
        title: "TEACHER PERFORMANCE",
        path: "teacherPerformance",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "DATA ENTRY PANEL",
    subNav: [
      {
        title: "TOPIC",
        subNav: [
          {
            title: "CREATE",
            path: "createtopic",
            cName: "sub-nav",
          },
          {
            title: "EDIT / DELETE",
            path: "editdeletetopic",
            cName: "sub-nav",
          },
        ],
      },
      {
        title: "SUB-TOPIC",
        subNav: [
          {
            title: "CREATE",
            path: "createsubtopic",
            cName: "sub-nav",
          },
          {
            title: "EDIT / DELETE",
            path: "editdeletesubtopic",
            cName: "sub-nav",
          },
        ],
      },
      {
        title: "LECTURE",
        subNav: [
          {
            title: "CREATE",
            path: "createLecture",
            cName: "sub-nav",
          },
          {
            title: "EDIT / DELETE",
            path: "editDeleteLecture",
            cName: "sub-nav",
          },
        ],
      },
      {
        title: "LIVE VIDEO",
        subNav: [
          {
            title: "ADD VIDEO",
            path: "addLiveVideoNew",
            cName: "sub-nav",
          },
          {
            title: "EDIT / DELETE",
            path: "editDeleteLiveVideoNew",
            cName: "sub-nav",
          },
        ],
      },
      {
        title: "PREMIER VIDEO",
        subNav: [
          {
            title: "ADD VIDEO",
            path: "addPremierVideo",
            cName: "sub-nav",
          },
          {
            title: "EDIT / DELETE",
            path: "editDeletePremierVideo",
            cName: "sub-nav",
          },
        ],
      },
      {
        title: "FREE USER VIDEO",
        subNav: [
          {
            title: "ADD VIDEO",
            path: "addFreeUserVideo",
            cName: "sub-nav",
          },
          {
            title: "EDIT / DELETE",
            path: "editDeleteFreeUserVideo",
            cName: "sub-nav",
          },
        ],
      },
      {
        title: "LIVE RECORDED VIDEO",
        subNav: [
          {
            title: "ADD VIDEO",
            path: "addliverecordedvideo",
            cName: "sub-nav",
          },
          {
            title: "EDIT / DELETE",
            path: "editdeleteliverecordedvideo",
            cName: "sub-nav",
          },
        ],
      },
      {
        title: "COPY RECORDED LECTURE",
        subNav: [
          {
            title: "COPY LECTURE",
            path: "copyrecordedlecture",
            cName: "sub-nav",
          },
          {
            title: "EDIT / DELETE",
            path: "editdeletecopyrecordedlecture",
            cName: "sub-nav",
          },
          {
            title: "BATCH CLONE",
            path: "batchClone",
            cName: "sub-nav",
          },
          {
            title: "BATCH CLONE & COPY LIVE TO LIVE LECTURE",
            path: "batchCloneCopyLiveToLiveLecture",
            cName: "sub-nav",
          },
          {
            title: "COPY LIVE TO RECORDED BATCH & RECORDED LECTURE",
            path: "copyLiveToRecordedBatchRecordedLecture",
            cName: "sub-nav",
          },
          {
            title: "COPY LIVE TO RECORDED BATCH",
            path: "liveToRecorded",
            cName: "sub-nav",
          },
          {
            title: "COPY LIVE TO RECORDED LECTURE",
            path: "liveToRecordedLecture",
            cName: "sub-nav",
          },
          {
            title: "COPY LIVE TO LIVE LECTURE",
            path: "liveToLiveLecture",
            cName: "sub-nav",
          },
        ],
      },
      {
        title: "NOTIFICATION",
        subNav: [
          {
            title: "CREATE",
            path: "createnotification",
            cName: "sub-nav",
          },
          {
            title: "EDIT / DELETE",
            path: "editdeletenotification",
            cName: "sub-nav",
          },
        ],
      },
      {
        title: "ASSIGN TEACHER",
        subNav: [
          {
            title: "CREATE",
            path: "createassignteacher",
            cName: "sub-nav",
          },
          {
            title: "EDIT / DELETE",
            path: "editdeleteassignteacher",
            cName: "sub-nav",
          },
        ],
      },
      {
        title: "ADD PART",
        path: "addPart",
        cName: "sub-nav",
      },
      {
        title: "EXAM SET",
        subNav: [
          {
            title: "CREATE",
            path: "createexamset",
            cName: "sub-nav",
          },
          {
            title: "EDIT / DELETE",
            path: "editdeleteexamset",
            cName: "sub-nav",
          },
          {
            title: "COPY EXAM SET",
            path: "copyexamset",
            cName: "sub-nav",
          },
          {
            title: "Question Bank Assign",
            path: "assignQuestionToExamSet",
            cName: "sub-nav",
          },
        ],
      },
      {
        title: "QUESTION",
        subNav: [
          {
            title: "CREATE",
            path: "createquestion",
            cName: "sub-nav",
          },
          {
            title: "EDIT / DELETE",
            path: "editdeletequestion",
            cName: "sub-nav",
          },
          {
            title: "SET QUESTION ORDER",
            path: "questionOrder",
            cName: "sub-nav",
          },
        ],
      },
      {
        title: "TEACHER SUPPORT",
        path: "teachersupport",
        cName: "sub-nav",
      },
      {
        title: "LIVE CLASS SCHEDULE",
        path: "liveclassschedule",
        cName: "sub-nav",
      },
      {
        title: "SYLLABUS",
        path: "syllabusDashboard",
        cName: "sub-nav",
      },
      {
        title: "QUESTION BANK",
        subNav: [
          {
            title: "CREATE",
            path: "questionBankEditor",
            cName: "sub-nav",
          },
          {
            title: "EDIT / DELETE",
            path: "editDeleteQuestionBank",
            cName: "sub-nav",
          },
          {
            title: "LECTURE ADD / EDIT",
            path: "replaceLecture",
            cName: "sub-nav",
          },
        ],
      },
      {
        title: "IMPORT QUESTIONS",
        path: "importQuestions",
        cName: "sub-nav",
      },
      {
        title: "COPY PACKAGE",
        subNav: [
          {
            title: "COPY PACKAGE",
            path: "copyPackage",
            cName: "sub-nav",
          },
          {
            title: "EDIT / DELETE",
            path: "editCopyPackage",
            cName: "sub-nav",
          },
        ],
      },
      {
        title: "Question Of The Day",
        subNav: [
          {
            title: "CREATE",
            path: "createQuestionOfTheday",
            cName: "sub-nav",
          },
          {
            title: "EDIT/DELETE",
            path: "editQuestionOftheday",
            cName: "sub-nav",
          },
        ],
      },
      {
        title: "MOCK TEST RESULT",
        path: "MockTestResult",
        cName: "sub-nav",
      },
      {
        title: "App Feature",
        subNav: [
          {
            title: "CREATE",
            path: "createAppFeature",
            cName: "sub-nav",
          },
          {
            title: "EDIT/DELETE",
            path: "editAppFeature",
            cName: "sub-nav",
          },
        ],
      },
      {
        title: "STUDENT MIGRATION",
        path: "studentMigration",
        cName: "sub-nav",
      },
      {
        title: "LECTURE LINK MANAGEMENT",
        path: "lectureLinkManagement",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "ADMIN PANEL",
    subNav: [
      {
        title: "EXAM NAME",
        subNav: [
          {
            title: "CREATE",
            path: "createexam",
            cName: "sub-nav",
          },
          {
            title: "EDIT / DELETE",
            path: "editdeleteexam",
            cName: "sub-nav",
          },
        ],
      },
      {
        title: "SUB EXAM NAME",
        subNav: [
          {
            title: "CREATE",
            path: "createsubexam",
            cName: "sub-nav",
          },
          {
            title: "EDIT / DELETE",
            path: "editdeletesubexam",
            cName: "sub-nav",
          },
        ],
      },
      {
        title: "EXAM STREAM",
        subNav: [
          {
            title: "CREATE",
            path: "createparentcourse",
            cName: "sub-nav",
          },
          {
            title: "EDIT / DELETE",
            path: "editdeleteparentcourse",
            cName: "sub-nav",
          },
        ],
      },
      {
        title: "EXAM CATEGORY",
        path: "createExamSection",
        cName: "sub-nav",
      },
      {
        title: "LANGUAGE",
        subNav: [
          {
            title: "CREATE",
            path: "createlanguage",
            cName: "sub-nav",
          },
          {
            title: "EDIT / DELETE",
            path: "editdeletelanguage",
            cName: "sub-nav",
          },
        ],
      },
      {
        title: "ASSIGN EXAM STREAM",
        path: "createassignexamstream",
        cName: "sub-nav",
      },
      {
        title: "SUBJECT",
        subNav: [
          {
            title: "CREATE",
            path: "createsubject",
            cName: "sub-nav",
          },
          {
            title: "EDIT / DELETE",
            path: "editdeletesubject",
            cName: "sub-nav",
          },
        ],
      },
      {
        title: "MAIN CATEGORY",
        subNav: [
          {
            title: "CREATE",
            path: "createmaincategory",
            cName: "sub-nav",
          },
          {
            title: "EDIT / DELETE",
            path: "editdeletemaincategory",
            cName: "sub-nav",
          },
        ],
      },
      {
        title: "SECTION",
        subNav: [
          {
            title: "CREATE",
            path: "createsection",
            cName: "sub-nav",
          },
          {
            title: "EDIT / DELETE",
            path: "editdeletesection",
            cName: "sub-nav",
          },
        ],
      },
      {
        title: "ASSIGN BOOKS",
        subNav: [
          {
            title: "CREATE",
            path: "createassignbooks",
            cName: "sub-nav",
          },
          {
            title: "EDIT / DELETE",
            path: "editdeleteassignbooks",
            cName: "sub-nav",
          },
        ],
      },
      {
        title: "PACKAGE",
        subNav: [
          {
            title: "CREATE",
            path: "createpackage",
            cName: "sub-nav",
          },
          {
            title: "EDIT / DELETE",
            path: "editdeletepackage",
            cName: "sub-nav",
          },
        ],
      },
      {
        title: "PACKAGE EXTEND",
        subNav: [
          {
            title: "CREATE",
            path: "createpackageextend",
            cName: "sub-nav",
          },
          {
            title: "EDIT / DELETE",
            path: "editdeletepackageextend",
            cName: "sub-nav",
          },
        ],
      },
      {
        title: "TEACHER",
        subNav: [
          {
            title: "CREATE",
            path: "createteacher",
            cName: "sub-nav",
          },
          {
            title: "EDIT / DELETE",
            path: "editdeleteteacher",
            cName: "sub-nav",
          },
        ],
      },
      {
        title: "ASSIGN UNITS",
        subNav: [
          {
            title: "CREATE",
            path: "createassignunits",
            cName: "sub-nav",
          },
          {
            title: "EDIT / DELETE",
            path: "editdeleteassignunit",
            cName: "sub-nav",
          },
        ],
      },
      {
        title: "PATTERN",
        subNav: [
          {
            title: "CREATE",
            path: "createpattern",
            cName: "sub-nav",
          },
          {
            title: "EDIT / DELETE",
            path: "editdeletepattern",
            cName: "sub-nav",
          },
        ],
      },
      {
        title: "BB MEETING ID",
        subNav: [
          {
            title: "CREATE",
            path: "createbbmeetingid",
            cName: "sub-nav",
          },
          {
            title: "EDIT / DELETE",
            path: "editdeletebbmeetingid",
            cName: "sub-nav",
          },
          {
            title: "BIND MEETING IDS",
            path: "bindbbbmeeting",
            cName: "sub-nav",
          },
        ],
      },
      {
        title: "BASE OFFER DISCOUNT",
        subNav: [
          {
            title: "ADD",
            path: "baseOfferDiscount",
            cName: "sub-nav",
          },
          {
            title: "EDIT / DELETE",
            path: "editBaseOfferDiscount",
            cName: "sub-nav",
          },
        ],
      },
      {
        title: "BASE PRICE",
        subNav: [
          {
            title: "ADD BASE PRICE",
            path: "createBasePrice",
            cName: "sub-nav",
          },
          {
            title: "EDIT / DELETE",
            path: "editDeleteBasePrice",
            cName: "sub-nav",
          },
        ],
      },
      {
        title: "FIXED DISCOUNT",
        subNav: [
          {
            title: "ADD FIXED DISCOUNT",
            path: "addFixedDiscount",
            cName: "sub-nav",
          },
          {
            title: "EDIT / DELETE",
            path: "editFixedDiscount",
            cName: "sub-nav",
          },
        ],
      },
      {
        title: "WEB FREE YT LECTURE",
        subNav: [
          {
            title: "ADD",
            path: "addFreeYTLectures",
            cName: "sub-nav",
          },
          {
            title: "EDIT / DELETE",
            path: "editFreeYTLectures",
            cName: "sub-nav",
          },
        ],
      },
      {
        title: "CATEGORY INCLUDE DESCRIPTION",
        path: "addNewCatDesc",
        cName: "sub-nav",
      },
      {
        title: "COPY CATEGORY INCLUDE",
        subNav: [
          {
            title: "COPY",
            path: "copyCategoryInclude",
            cName: "sub-nav",
          },
          {
            title: "EDIT/DELETE",
            path: "editDeleteCategoryInclude",
            cName: "sub-nav",
          },
        ],
      },
      {
        title: "ADD RECORDED LECTURE IN COURSE",
        path: "addRecordedLectureInCourse",
        cName: "sub-nav",
      },
      {
        title: "BATCH ANALYSIS",
        path: "batchAnalysis",
        cName: "sub-nav",
      },
      {
        title: "Festive Banner",
        subNav: [
          {
            title: "ADD",
            path: "addFestiveBanner",
            cName: "sub-nav",
          },
        ],
      },
      {
        title: "Global Special Discount",
        path: "globalSpecialDiscount",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "MOVEMENTS OF MEETING",
    subNav: [
      {
        title: "MOVEMENTS OF MEETING",
        path: "movementsOfMeeting",
        cName: "sub-nav",
      },
      {
        title: "EDIT/DELETE",
        path: "editMovementsOfMeeting",
        cName: "sub-nav",
      },
    ],
  },
];
